export default {
  label: "Gestión de Dispositivos",
  tabs: {
    devices: {
      label: "Dispositivos",
      addButton: "Agregar Dispositivo",
      tags: "Etiquetas",
      configuration: "Configuración",
      update: "Actualizar",
      assignments: "Asignaciones",
      makeAssignment: "Hacer Asignación",
      unassign: "desasignar",
      logs: "registros",
      device: "Dispositivo",
    },
    deviceGroups: {
      label: "Grupos de Dispositivos",
      list: "Lista de Dispositivos",
      activities: "Actividades",
      newDeviceGroup: "Nuevo Grupo de Dispositivos",
    },
    deviceTypes: {
      label: "Tipo de Dispositivo",
      addButton: "Agregar Modelo",
      editModel: "Editar",
      deleteModel: "Eliminar",
      newDeviceType: "Nuevo Tipo de Dispositivo",
    },
    deviceDetails: {
      label: "Detalles del dispositivo",
    },
  },
};
